import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { fLong, plural } from "../../lib/format";
import { fetchYear, type YearReview } from "../../lib/statsPage";
import { useApp } from "../appState";
import { Sheet } from "../Sheet";

export function YearSheet({ year }: { year: number }) {
  const { open, close, version } = useApp();
  const navigate = useNavigate();
  const [r, setR] = useState<YearReview | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    fetchYear(year)
      .then((d) => live && setR(d))
      .catch((e: Error) => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [year, version]);

  return (
    <Sheet title={String(year)} label={`${year} in review`} onClose={close}>
      {error && <p className="error">{error}</p>}
      {!r && !error && <p className="loading">Loading…</p>}
      {r && (
        <>
          <div className="mono muted" style={{ marginTop: -10 }}>
            {plural(r.shows, "show")} · {plural(r.bands, "band")} · {plural(r.venues, "venue")}
          </div>
          <div className="split">
            <section>
              <p className="eyebrow">Most seen</p>
              <div className="facts">
                {r.top_bands.map((b) => (
                  <button type="button" key={b.id} onClick={() => open("band", b.id)}>
                    <span className="fk">{b.name}</span>
                    <span className="fv2 mono">{b.count}</span>
                  </button>
                ))}
              </div>
            </section>
            <section>
              <p className="eyebrow">Venues</p>
              <div className="facts">
                {r.top_venues.map((v) => (
                  <button type="button" key={v.id} onClick={() => open("venue", v.id)}>
                    <span className="fk">{v.name}</span>
                    <span className="fv2 mono">{v.count}</span>
                  </button>
                ))}
              </div>
            </section>
          </div>
          <section>
            <p className="eyebrow" style={{ marginBottom: 4 }}>First and last</p>
            <div className="facts">
              {[["First", r.first], ["Last", r.last]].map(([label, s]) => {
                const show = s as YearReview["first"];
                return (
                  <button type="button" key={label as string} onClick={() => open("show", show.id)}>
                    <span className="fk">{label as string} · {fLong(show.date)}</span>
                    <span className="fv2">{show.venue}</span>
                  </button>
                );
              })}
            </div>
          </section>
          <button type="button" className="btn ghost" onClick={() => navigate(`/?year=${year}`)}>
            See all {r.shows} in Shows
          </button>
        </>
      )}
    </Sheet>
  );
}
